/* jshint latedef: nofunc */

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
function gtm_onFormSuccess(formId) {
  window.dataLayer = window.dataLayer || [];
  formId = formId || 'quoteForm';
  window.dataLayer.push({
    'event' : 'formSubmissionSuccess',
    'formId' : formId
  });

  jQuery('#' + formId).find('.focused').removeClass('focused');
  jQuery('#' + formId).find('textarea').height(84);

  if ( jQuery('#' + formId + ' .file-attachment').length ) {
      jQuery('#' + formId + ' .file-attachment').css( 'top', 92 + 'px' );
  }
}

function formatBytes(bytes, decimals) {
    if ( 0 === bytes ) {
        return '0 Bytes';
    }

    var k = 1024,
        dm = decimals || 2,
        sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat( (bytes / Math.pow(k, i) ).toFixed(dm)) + ' ' + sizes[i];
}

(function($) {
  function findBootstrapEnvironment() {
    var envs = ['xs', 'sm', 'md', 'lg'];

    var $el = $('<div>');
    $el.appendTo($('body'));

    for (var i = envs.length - 1; i >= 0; i--) {
        var env = envs[i];

        $el.addClass('hidden-'+env);
        if ($el.is(':hidden')) {
            $el.remove();
            return env;
        }
    }
  }

  function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // Commented 08.2018, this prevents mobile submenu from expanding
        $('.dropdown-toggle').on('click', function() {
            var parent = $(this).closest('.collapse');

            if ( !parent.length || !parent.hasClass('in') ) {
                if (!isTouchDevice()) {
                    var location = $(this).attr('href');
                    window.location.href = location;
                    return false;
                }
            }
        });
        $('.dropdown-toggle').on('taphold', function() {
            var location = $(this).attr('href');
            window.location.href = location;
            return false;
        });

        $('.mobile-dropdown-toggler').dropdown();

        $('#portfolio-carousel').on('mouseover', function() {
            $('.carousel-control').css('opacity', '1');
        }).on('mouseout', function() {
            $('.carousel-control').css('opacity', '0');
        });
        $('.carousel-control').on('mouseover', function() {
            $(this).css('opacity', '1');
        }).on('mouseout', function() {
            $(this).css('opacity', '0');
        });

        // Carousel - fixing issue when slides have different height
        var resizeCarousel = function() {
            $('.carousel-inner').each( function() {
                var minHeight = 0;

                $(this).find('.item').each( function() {
                    $(this).css('min-height', 0);
                    $(this).css('height', 'auto');
                });

                $(this).find('.item').each( function() {
                    minHeight = Math.max( minHeight, $(this).outerHeight() );
                });

                $(this).find('.item').each( function() {
                    $(this).css('min-height', minHeight);
                    $(this).css('height', minHeight);
                });
            });
        };

        resizeCarousel();

        $(window).resize(resizeCarousel);

        if ( 'object' === typeof window.infiniteScroll ) {
            window.infiniteScroll.settings.type = 'click';
        }

        // Burger menu, expand sub-items
        $('.nav-primary').on('click', '#primary-navbar-collapse.collapse.in .dropdown-toggle', function(e) {
            e.preventDefault();
            $(this).dropdown('toggle');
        });

        // Show the header when scrolling top
        var prevScroll = $(this).scrollTop();

        var scrollIsOnTop = function() {
            var newScroll = $(this).scrollTop();

            return ( $('.nav-collapsable').hasClass('nav-primary') && newScroll <= 0 ) ||
                    ( $('.nav-collapsable').hasClass('navbar-secondary') && newScroll <= 86 );
        };

        var noStickyNav = function() {
            $('.nav-collapsable').removeClass('navbar-fixed-top');
            $('.nav-collapsable').collapse('show');
        };

            $(window).scroll( function(e) {
            var newScroll = $(this).scrollTop(),
                change = newScroll - prevScroll,
                delta = 3;

            if ( scrollIsOnTop() ) {
                noStickyNav();
            } else {
                if ( change <= -delta ) {
                    $('.nav-collapsable').collapse('show');
                } else if ( change > delta ) {
                    $('.nav-collapsable').collapse('hide');
                }
            }

            prevScroll = newScroll;

            $(document).trigger('nav_update');
        });

        $('.nav-collapsable').on('show.bs.collapse', function () {
            if ( !scrollIsOnTop() ) {
                $('.nav-collapsable').addClass('navbar-fixed-top');
            }
        });

        $('.nav-collapsable').on('hidden.bs.collapse', function () {
            if ( scrollIsOnTop() ) {
                noStickyNav();
            }
        });

        $('.nav-collapsable').on('shown.bs.collapse hidden.bs.collapse', function () {
            $(document).trigger('nav_update');
        });

        // Dropdown categories submenu on hover
        $('.navbar-secondary li.dropdown:not(.mobile-dropdown)').on('mouseover', function() {
            $(this).addClass('open');
        }).on('mouseout', function() {
            $(this).removeClass('open');
        });

        // Search in the categories menu
        $('.nav-categories-search a').click( function(e) {
            e.preventDefault();

            $('.navbar-secondary .nav > li').addClass('hidden');
            $('.nav-categories-search-form').removeClass('hidden');
            $('.nav-categories-search-form .search-field').focus();
        });

        // Remove search from categories menu
        $('.nav-categories-search-form .search-field').blur( function(e) {
            if ( $('.nav-categories-search-form:hover').length === 0 ) {
                $('.navbar-secondary .nav > li').removeClass('hidden');
                $('.nav-categories-search-form').addClass('hidden');
            }
        });

        $('.nav-categories-search-form').submit( function(e) {
            if ( !$('.nav-categories-search-form .search-field').val().length ) {
                $('.nav-categories-search-form .search-field').focus();
                return false;
            }

            return true;
        });

        // Forms labels animation
        var formInputFocus = function() {
            var group = $(this).closest('#commentform').length ? $(this).closest('p') : $(this).closest('.form-group');

            if ( group.length ) {
                group.addClass('focused');
            }
        };

        var formInputBlur = function() {
            var group = $(this).closest('#commentform').length ? $(this).closest('p') : $(this).closest('.form-group');

            if ( group.length ) {
                if ( !$(this).val().length ) {
                    group.removeClass('focused');
                }
            }
        };

        $('.form-group').on('focus', '.form-control', formInputFocus);
        $('#commentform').on('focus', 'textarea, input[type="text"], input[type="email"], input[type="url"]', formInputFocus);

        $('.form-group').on('blur', '.form-control', formInputBlur);
        $('#commentform').on('blur', 'textarea, input[type="text"], input[type="email"], input[type="url"]', formInputBlur);

        $('.form-group').on('select2:opening', '.select2-hidden-accessible', function() {
            var group = $(this).closest('.form-group');

            if ( group.length ) {
                group.addClass('focused');
            }
        });

        $('.form-group').on('select2:closing', '.select2-hidden-accessible', function() {
            var group = $(this).closest('.form-group');

            if ( group.length ) {
                if ( !$(this).val().length ) {
                    group.removeClass('focused');
                }
            }
        });

        // Do not allow to share comment until it is approved
        $('.wc_held_for_moderate').each( function() {
            $(this).closest('.wc-comment-right').find('.wc-comment-link').remove();
        });

        // Resize textarea for content
        $(document).ready( function() {
            if ( $('#commentform #comment').length ) {
                $('#commentform #comment').attr('rows', '3');
            }
        });

        $('form').on('input', 'textarea', function() {
            if ( $(this).closest('#wpcomm').length ) {
                return;
            }

            $(this).height( 'auto' );
            $(this).height( Math.max(84, $(this)[0].scrollHeight ) );
        });

        // File attachments behavior
        if ( $('#file-attachment').length ) {
            $('.file-attachment').click( function(e) {
                $('#file-attachment')[0].click();
            });

            $('#file-attachment').change( function() {
                var files   = $(this)[0].files,
                    message = $('#contact-message'),
                    group   = message.closest('.form-group');

                $('.file-attachment').find('.file-info').remove();

                if ( files.length ) {
                    var size = formatBytes(files[0].size);

                    $('.file-attachment').prepend(
                        $('<span class="file-info name" title="' + files[0].name + '">' + files[0].name + '</span>' +
                            '<span class="file-info size">' + size + '</span>' +
                            '<span class="file-info fa fa-times"></span>') );

                    group.addClass('focused');
                } else {
                    if ( message.val().length ) {
                        group.addClass('focused');
                    } else {
                        group.removeClass('focused');
                    }
                }
            });

            $('.file-attachment').on('click', '.fa-times', function(e) {
                e.preventDefault();
                e.stopPropagation();

                $('#file-attachment').val('');
                $('.file-attachment').find('.file-info').remove();

                var message = $('#contact-message'),
                    group   = message.closest('.form-group');

                if ( message.val().length ) {
                    group.addClass('focused');
                } else {
                    group.removeClass('focused');
                }
            });

            $('.form-group').on('blur', '.form-control', function() {
                if ( !$(this).is('textarea') ) {
                    return;
                }

                var group = $(this).closest('.form-group');

                if ( group.length ) {
                    if ( !$(this).val().length && !$('#file-attachment')[0].files.length ) {
                        group.removeClass('focused');
                    }
                }
            });

            // Forms labels animation
            $('form').on('input', 'textarea.form-control', function() {
                var top = $(this).closest('.form-group').height() - 10;
console.log( $(this).closest('.form-group').height() );
console.log( top );
                $('.file-attachment').css( 'top', top + 'px' );
            });

            $(document).on( 'wpcf7mailsent', function( event ) {
                $('.select2-hidden-accessible').val('').trigger('change');
                $('.file-attachment .fa-times').trigger('click');

                $('.focused').removeClass('focused');
            });
        }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'blog': {
      init: function() {
        $( document.body ).on( 'post-load', function () {
            // New posts have been added to the page.
            $('.wp-pagenavi').remove();
        } );
      }
    },
    'post_template_default': {
      init: function() {
          var sidebar       = $('.sidebar'),
              offsetTop     = sidebar.offset().top,
              childHeight   = 0;

          sidebar.children().each( function() {
              childHeight += $(this).outerHeight(true);
          });

          $(document).on('nav_update', function() {
              var max       = $('main.main .entry-content').first().height() - childHeight,
                  scrollTop = $(window).scrollTop(),
                  padding   = 0;

                  if ( scrollTop > 1 ) {
                      padding   = Math.min( scrollTop, max ) + ( offsetTop - sidebar.offset().top );
                  }

              sidebar.stop().animate({
                  paddingTop: padding,
              });
          });

          // Share highlighted text
          var shareThis = window.ShareThis({
              selector: '.entry-content:not(.post-tags)',
              sharers: [
                  window.ShareThisViaTwitter,
                  window.ShareThisViaFacebook,
                  window.ShareThisViaLinkedin,
              ],
              onOpen: function(popover) {
                  popover.style.right = "";
                  popover.style.maxWidth = "none";

                  var range = getSelection().getRangeAt(0),
                      rect = range.getBoundingClientRect();

                  popover.style.top     = rect.top + window.pageYOffset + "px";
                  popover.style.left    = rect.left + "px";
                  popover.style.width   = rect.width + "px";
                  popover.style.height  = rect.height + "px";
              },
          });

          shareThis.init();

          // Post ratings
          var ratingHints = ['Pff', 'Meh', 'Hmm', 'Mmm', 'Wow!'];

          var setRatingsText = function () {
              for (var i = 0; i < ratingHints.length; i++ ) {
                  $( '.post-ratings .rating i:nth-child(' + (i+1) + ')' ).html( '<span>' + ratingHints[i] + '</span>' );
                  $( '.post-ratings .rating i:nth-child(' + (i+1) + ')' ).removeAttr('title');
              }

              $( '.post-ratings .rating' ).removeAttr('title');
              $( '.post-ratings .rating i' ).removeClass('voted');

              var vote = $( '.post-ratings .rating' ).attr('data-vote');

              if ( vote.length ) {
                  $( '.post-ratings .rating i:nth-child(' + vote + ')' ).addClass('voted');
              }
          };

          if ( $('.post-ratings').length ) {

              $('.rating').raty('set', {
                    hints:      ratingHints,
                    single:     true,
              });

              setRatingsText();
              $('.post-ratings').on('rated_post', function(response) {
                  var rating = $('.post-ratings .rating');

                  rating.addClass('voted');
                  rating.attr('data-readonly', 1);
                  rating.attr('data-vote', rating.find('input[name="score"]').val() );

                  setRatingsText();
              });
          }
      }
    },
    'post_type_archive_portfolio': {
      init: function() {
        // Portfolio top menu
        window.portfolioWidget.init();
      }
    },
    'estimate_project': {
      init: function() {
        $('select#budget').select2({
            theme: "bootstrap",
            // placeholder: "Budget (optional)",
            allowClear: false,
            minimumResultsForSearch: -1,
            width: null
        });

        // Phone number with codes
        $('#contact-phone').mobilePhoneNumber();

        $('#contact-phone').on('country.mobilePhoneNumber', function(e, country) {
            $('#phone_country').val(country || '');
        });
      }
    },
    'careers': {
      init: function() {
        $('select#position').select2({
            theme: "bootstrap",
            // placeholder: "Select position",
            allowClear: false,
            minimumResultsForSearch: -1,
            width: null
        });
      }
    },
    // Services page
    'services': {
      init: function() {
        function switchSecondary(active, target) {
            var buttons = ['.js-menu-wd', '.js-menu-md', '.js-menu-ec', '.js-menu-ui', '.js-menu-wp', '.js-menu-it'];

            $.each(buttons, function (_i, btn) {
                $(btn).removeClass('active');
            });

            $(active).addClass('active');

            if ( undefined !== target ) {
                target = 'a[name="' + target.replace('#', '') + '"]';

                $('html, body').animate({
                    scrollTop: $(target).offset().top - 161 - $('.nav-primary').height(),
                }, 300);
            }
        }

        function secondaryNav() {

            var bs = findBootstrapEnvironment();
            if (bs === 'xs' || bs === 'sm') {
                return;
            }

            var offsetMod = -161;
            var $secondaryNav = $('.nav-secondary');
            var $primaryNav = $('.nav-primary');

            // on click
            $secondaryNav.on('click', 'a', function (e) {
                e.preventDefault();

                switchSecondary( '.'+$(this).attr('class'), $(this).attr('href') );
            });
            $('.services-tabs').on('click','a', function (e) {
                e.preventDefault();
                switchSecondary( '.'+$(this).attr('class'), $(this).attr('href') );
            });

            // on scroll
            var offsetList = {'wd':0,'md':0,'ec':0,'ui':0,'wp':0,'it':0};
            for (var key in offsetList) {
                if (offsetList.hasOwnProperty(key)) {
                    offsetList[key] = $('.js-info-'+key).offset().top + offsetMod;
                }
            }
            offsetList.end = $('.js-info-it').offset().top + $('.js-info-it').outerHeight() * 4;

	    $(window).scroll(function () {
	      var currentScroll = $(window).scrollTop() + ( $(window).height() * 0.4 );

	      if (currentScroll > offsetList.wd && currentScroll < offsetList.end) {
	        $secondaryNav.removeClass('hidden');
                $primaryNav.addClass('hidden');

	        if (currentScroll > offsetList.wd && currentScroll < offsetList.md) {
	          switchSecondary('.js-menu-wd');
	        }
	        if (currentScroll > offsetList.md && currentScroll < offsetList.ec) {
	          switchSecondary('.js-menu-md');
	        }
	        if (currentScroll > offsetList.ec && currentScroll < offsetList.ui) {
	          switchSecondary('.js-menu-ec');
	        }
                if (currentScroll > offsetList.ui && currentScroll < offsetList.wp) {
	          switchSecondary('.js-menu-ui');
	        }
                if (currentScroll > offsetList.wp && currentScroll < offsetList.it) {
	          switchSecondary('.js-menu-wp');
	        }
	        if (currentScroll > offsetList.it) {
	          switchSecondary('.js-menu-it');
	        }
	      }

	      if (!$secondaryNav.hasClass('hidden')) {
	        if (currentScroll < offsetList.wd || currentScroll > offsetList.end) {
	          $secondaryNav.addClass('hidden');
                  $primaryNav.removeClass('hidden');
	        }
	      }
	    });
	  }


          // RUN
          secondaryNav();
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);


})(jQuery); // Fully reference jQuery after this point.
